import React from 'react';

import { useFormikContext } from 'formik';
import { useTranslation } from 'i18n/hooks';
import { FormControl } from 'revibe-ui';
import { SpacedContainer } from 'revibe-ui';

import { useMediaQuery } from 'modules/common/hooks';
import { ITEM_FILTERS } from 'modules/item/utils/itemFilter';

import { Input } from 'ui/components/Input';
import { MarketplaceAPI } from 'revibe-api';

export const PRICE_FILTER_LIMITS = {
  MIN: 0,
  MAX: 1000,
};

export const PriceFilter = () => {
  const { tu } = useTranslation('listing.filters');
  const { values, setFieldValue, handleSubmit } =
    useFormikContext<MarketplaceAPI.ItemFilters>();
  const { isMobile } = useMediaQuery();

  return (
    <SpacedContainer type="horizontal" className="child:w-full w-full">
      <FormControl label={`${tu('price')} (min)`}>
        <Input
          value={values[ITEM_FILTERS.MIN_PRICE]}
          onChange={(e) => {
            if (/^\d+$/.test(e.currentTarget.value)) {
              setFieldValue(ITEM_FILTERS.MIN_PRICE, e.currentTarget.value);
            } else if (!e.currentTarget.value) {
              setFieldValue(ITEM_FILTERS.MIN_PRICE, undefined);
            }
            !isMobile && handleSubmit();
          }}
          type="number"
          min={0}
          max={1000}
          placeholder="0 €"
        />
      </FormControl>
      <FormControl label={`${tu('price')} (max)`}>
        <Input
          value={values[ITEM_FILTERS.MAX_PRICE]}
          onChange={(e) => {
            if (/^\d+$/.test(e.currentTarget.value)) {
              setFieldValue(ITEM_FILTERS.MAX_PRICE, e.currentTarget.value);
            } else if (!e.currentTarget.value) {
              setFieldValue(ITEM_FILTERS.MAX_PRICE, undefined);
            }
            !isMobile && handleSubmit();
          }}
          type="number"
          placeholder="1000 €"
          min={0}
          max={1000}
        />
      </FormControl>
    </SpacedContainer>
  );
};
